exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page[data-v-1c625f6c]{width:100%}.column[data-v-1c625f6c]{display:-webkit-box;display:-ms-flexbox;display:flex}", ""]);

// exports
